import { DeleteOccurrenceAgendaSlotApiPayload } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { z } from 'zod';
import http from '@/utils/http.service';

const deleteOccurrenceAgendaSlotResponseSchema = z.object({
  id: z.string().uuid(),
  exdate: z.array(z.string()),
});

export type DeleteOccurrenceAgendaSlotResponse = z.infer<
  typeof deleteOccurrenceAgendaSlotResponseSchema
>;
export type DeleteOccurrenceAgendaSlotPayload = {
  id: string;
} & DeleteOccurrenceAgendaSlotApiPayload;

const deleteOccurenceAgendaSlot = (
  payload: DeleteOccurrenceAgendaSlotPayload,
) => {
  return http.agendaSlots
    .deleteOccurrence(payload.id, {
      exdate: payload.exdate,
    })
    .then<DeleteOccurrenceAgendaSlotResponse>(({ response, transform }) => {
      return transform.handle({
        response,
        attributes: {
          exdate: true,
        },
        schema: deleteOccurrenceAgendaSlotResponseSchema,
      });
    });
};

const useDeleteOccurrenceAgendaSlotMutation = (): UseMutationResult<
  DeleteOccurrenceAgendaSlotResponse,
  Error,
  DeleteOccurrenceAgendaSlotPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: deleteOccurenceAgendaSlot,
    onSuccess() {
      toast.success(t('http.delete-occurence-agenda-slot.success'));
    },
  });
};

export default useDeleteOccurrenceAgendaSlotMutation;
